import { Button, Modal } from 'antd';
import { useEffect, useState } from 'react';

//Import css
import '../styles/userGuideModal.less';

//Import Images
import Arrow from '../../../assets/images/direction-arrow.png';
import SetDirection_GIF from '../../../assets/images/direction-change.gif';
import Direction_GIF from '../../../assets/images/entrance-first.gif';
import WhiteArrow from '../../../assets/images/white-arrow.png';

export default function SelectDirectionModal({
  visible,
  onClose,
}: {
  visible: boolean;
  onClose: () => void;
}) {
  const [currentStep, setCurrentStep] = useState(1);

  useEffect(() => {
    if (visible) setCurrentStep(1);
  }, [visible]);

  return (
    <div className="entrance-shows-modal">
      <Modal
        title={
          currentStep === 1
            ? 'Drag the arrow to your main entrance door'
            : 'Choose your door’s entry direction'
        }
        open={visible}
        footer={null}
        onCancel={onClose}
      >
        {currentStep === 1 ? (
          <div className="arrow-modal-container">
            <img src={Direction_GIF} alt="Arrow Direction" />
            <Button
              className="modal-btn"
              type="primary"
              onClick={() => setCurrentStep(2)}
            >
              Next
            </Button>
          </div>
        ) : (
          <div className="arrow-modal-container">
            <img
              src={SetDirection_GIF}
              alt="Loading..."
              className="ser-direction-gif-image"
            />
            <div className="direction-choice-buttons">
              {['left', 'top', 'bottom', 'right'].map((dir, index) => (
                <Button key={index} className={`direction-button-modal ${dir}`}>
                  <img
                    src={dir === 'left' ? WhiteArrow : Arrow}
                    alt={`${dir} Arrow`}
                  />
                </Button>
              ))}
            </div>
            <Button className="modal-btn" type="primary" onClick={onClose}>
              Got it
            </Button>
          </div>
        )}
      </Modal>
    </div>
  );
}
